import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const getModeratorContributorComments = (id) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.MODERATE_CONTRIBUTIONS.GET_MODERATOR_CONTRIBUTOR_COMMENTS(
      id
    )
  );
};

export default getModeratorContributorComments;
